import type { Competition } from '../../api/leagues.ts';

/**
 * Temporada preseleccionada al crear una liga.
 *
 * La fuente de verdad es `is_current`, que escribe el sync con el `ACTIVE_SEASON_YEAR`
 * configurado (H2). NO se deduce del año: cuando la 2026-27 aparezca en el proveedor y se
 * sincronice para irla preparando, seguirá sin ser la temporada en curso, y elegirla por
 * "la más reciente" mandaría a todo el mundo a una liga vacía.
 *
 * El respaldo por año existe porque el catálogo puede tener temporadas antes de que el
 * sync haya corrido nunca: sin él, el formulario saldría sin temporada elegida.
 */
export function temporadaPorDefecto(competicion: Competition): number | null {
  const enCurso = competicion.seasons.find((s) => s.is_current);
  if (enCurso) return enCurso.id;

  const masReciente = competicion.seasons.reduce<Competition['seasons'][number] | null>(
    (mejor, s) => (mejor === null || s.start_year > mejor.start_year ? s : mejor),
    null,
  );
  return masReciente?.id ?? null;
}
